import { render } from "./home-grid-single.vue?vue&type=template&id=7948b9bc&scoped=true"
import script from "./home-grid-single.vue?vue&type=script&lang=js"
export * from "./home-grid-single.vue?vue&type=script&lang=js"

import "./home-grid-single.vue?vue&type=style&index=0&id=7948b9bc&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7948b9bc"]])

export default __exports__